<template>
  <router-view />
</template>

<script setup>
import { useI18n } from 'vue-i18n'

// cria um composer LOCAL no App e passa-o aos filhos
useI18n({ useScope: 'local', inheritLocale: true })
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700&display=swap');

#app {
  font-family: 'Montserrat', sans-serif;
}

/* esconder barra de scroll em WebKit */
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none;
}

/* opcional: evitar overscroll/bounce em mobile */
html, body {
  overscroll-behavior: none;
}
</style>
